export default __webpack_public_path__ + "static/media/newuser.9d3f9051.png";